<template>
  <section
    id="set-password-page"
    :dir="$functions.currentLangDirection()"
    style="width: 100vw;
            padding: 0px !important;
            margin: 0px !important;
            top: 62px !important;
            left: 0px !important;"
  >
    <b-card style="height: calc(100vh);top: -60px;">
      <b-card-body>
        <h4 style="margin-bottom: 15px;">
          <v-icon
            size="22"
            color="#555"
          >mdi-lock-reset</v-icon>
          تنظیم رمز عبور
        </h4>
        <p style="color: #777;font-size: 0.85rem;margin-bottom: 20px;">
          با تنظیم رمز عبور می‌توانید علاوه بر رمز پیامکی، با رمز عبور نیز وارد حساب خود شوید.
        </p>

        <!-- فرم تنظیم رمز عبور -->
        <template v-if="!success">
          <b-form-group label="رمز عبور جدید">
            <b-input-group>
              <b-form-input
                v-model="newPassword"
                :type="showPassword ? 'text' : 'password'"
                placeholder="حداقل 6 کاراکتر"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="showPassword ? 'EyeOffIcon' : 'EyeIcon'"
                  @click="showPassword = !showPassword"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-muted">حداقل 6 کاراکتر</small>
            <br>
            <small class="text-danger">{{ passwordError }}</small>
          </b-form-group>

          <b-form-group label="تکرار رمز عبور جدید">
            <b-input-group>
              <b-form-input
                v-model="confirmPassword"
                :type="showPassword ? 'text' : 'password'"
                placeholder="رمز عبور را مجددا وارد کنید"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="showPassword ? 'EyeOffIcon' : 'EyeIcon'"
                  @click="showPassword = !showPassword"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ confirmError }}</small>
          </b-form-group>

          <b-button
            variant="success"
            block
            :disabled="loading"
            @click="submitSetPassword"
          >
            <b-spinner
              v-if="loading"
              small
            />
            ثبت رمز عبور
          </b-button>
        </template>

        <!-- پیام موفقیت -->
        <template v-if="success">
          <div class="text-center py-3">
            <div class="sp-ok mx-auto mb-1">
              <feather-icon
                icon="CheckIcon"
                size="32"
                style="color: #fff;"
              />
            </div>
            <h4>رمز عبور با موفقیت تنظیم شد</h4>
            <p class="text-muted">
              اکنون می‌توانید با شماره موبایل و رمز عبور وارد حساب خود شوید.
            </p>
            <b-button
              variant="success"
              @click="$router.push('/')"
            >
              بازگشت به صفحه اصلی
            </b-button>
          </div>
        </template>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import {
  BCard, BCardBody, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BSpinner,
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      passwordError: '',
      confirmError: '',
      loading: false,
      success: false,
      showPassword: false,
    }
  },
  methods: {
    submitSetPassword() {
      this.passwordError = ''
      this.confirmError = ''

      let hasError = false
      if (!this.newPassword || this.newPassword.length < 6) {
        this.passwordError = 'رمز عبور باید حداقل 6 کاراکتر باشد'
        hasError = true
      }
      if (this.newPassword !== this.confirmPassword) {
        this.confirmError = 'رمز عبور و تکرار آن مطابقت ندارند'
        hasError = true
      }
      if (hasError) return

      this.loading = true
      this.$store.dispatch('auth/setPassword', {
        password: this.newPassword,
      }).then(
        () => {
          this.loading = false
          this.success = true
        },
        error => {
          this.loading = false
          const msg = (error.response && error.response.data)
            || error.message
            || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: msg,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
  },
}
</script>

<style>
#set-password-page {
  z-index: 9;
}
#set-password-page .card,
#set-password-page .card-body {
  border-radius: 0;
}
.sp-ok {
  width: 60px;
  height: 60px;
  background: #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
